/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';

export const Title = styled.h2`
  font-size: 28px;
  font-weight: bolder;
  @media (max-width: 480px) {
    text-align: center;
  }
`;

export const IconImage = styled(Image)`
  width: 20px;
  height: 20px;
`;

export const SubTitle = styled.h5`
font-size:16px;
@media (max-width: 480px) {
    text-align:center;
`;
